export default "__VITE_ASSET__DfyHTJlS__"